import React, { useState, useRef, useEffect } from "react"
import { Form, Alert, Button, Card, Col, Row, Spinner } from "react-bootstrap"
import { useAuth } from "../contexts/AuthContext"
import { db } from "../firebase"
import { doc, getDoc, updateDoc } from "firebase/firestore"
import CenteredContainer from "./CenteredContainer"
import Image from "react-bootstrap/Image"
import { useHistory } from "react-router-dom"
import {
  optionsDegree,
  optionsOccupation,
  optionsAffiliation,
} from "../helpers/Data"

// import Nav from 'react-bootstrap/Nav';

export default function NewUser() {
  const [error, setError] = useState("")
  const { currentUser } = useAuth()
  const affiliationRef = useRef()
  const degreeRef = useRef()
  const nameRef = useRef()
  const surnameRef = useRef()
  const occupationRef = useRef()
  const paperRef = useRef(0)

  const [selectedAffiliation, setSelectedAffiliation] = useState("")
  const [affiliationText, setAffiliationText] = useState("")

  const history = useHistory()

  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState("")

  const [currentProfile, setCurrentProfile] = useState({})

  const docRef = doc(db, "usersNew", currentUser.uid)

  useEffect(() => {
    ;(async () => docSnap())()
  }, [])

  const docSnap = async () => {
    setLoading(true)
    // Get current profile
    const res = await getDoc(docRef)
    // Set current profile
    setCurrentProfile(res.data())

    // Reset loading state
    setLoading(false)
  }

  // selectElement('degree', 'Master');
  // Update profile data
  async function updateProfile(newProfileData) {
    const data = newProfileData
    console.log("new profile data", newProfileData)
    try {
      await updateDoc(docRef, data)
    } catch (err) {
      console.log(err)
    }
  }

  // Submit changes to profile
  async function handleSubmit(e) {
    e.preventDefault()

    // const promises = []
    setLoading(true)
    setError("")

    let newProfileData = {}

    // Update Name field
    if (nameRef.current.value !== "") {
      newProfileData.Name = nameRef.current.value
    }

    // Update Surname field
    if (surnameRef.current.value !== "") {
      newProfileData.Surname = surnameRef.current.value
    }

    // update Affiliation field
    if (affiliationRef.current.value !== "") {
      newProfileData.Affiliation = affiliationRef.current.value
    }

    // Update Degree field
    if (degreeRef.current.value !== "") {
      newProfileData.Degree = degreeRef.current.value
    }

    // Update occupation field
    if (occupationRef.current.value !== "") {
      newProfileData.occupation = occupationRef.current.value
    }

    // Paper ref
    newProfileData.paperID = paperRef.current.value

    LoadSpinner()
    try {
      await updateProfile(newProfileData)
    } catch (err) {
      setError(err.message)
      setMessage(error)
    }

    // setLoading(false)

    history.push("/")
  }

  const LoadSpinner = () => {
    return (
      <>
        {loading && (
          <div className={"d-flex justify-content-center"}>
            <Spinner animation='border' role='status'>
              <span className='visually-hidden'> Loading...</span>
            </Spinner>
          </div>
        )}
      </>
    )
  }

  const handleDropdownChange = (event) => {
    const selectedValue = event.target.value
    setSelectedAffiliation(selectedValue)
    affiliationRef.current.value = selectedValue // Update affiliationRef value
    if (selectedValue === "Otro") {
      affiliationRef.current.focus()
    }
  }

  const handleTextChange = (event) => {
    setAffiliationText(event.target.value)
  }

  return (
    <CenteredContainer>
      {/*  Update Profile */}
      <Card>
        <Image
          src={require("../images/Group9.jpeg")}
          rounded
          className='w-100'
          style={{ maxWidth: "400px" }}
        ></Image>
      </Card>
      <Card className='mt-1'>
        <Card.Body>
          <h2 className='mt-4 text-center'>Tus datos</h2>
          <p className='text-center fs-6 text-secondary'>
            {" "}
            Personal information
          </p>

          <hr className='hr-danger' />
          <div className='w-100 fs-6 text-center mt-2'>
            No compartimos tus datos con nadie.
          </div>
          <div className='w-100 fs-16 text-secondary text-center mt-0'>
            We do not share any of your information.
          </div>

          {message && <Alert variant='warning'>message</Alert>}
          {/* {message==="Nochange" && <Alert variant="warning">Nada que actualizar</Alert> } */}

          <hr className='hr-danger' />

          <Form onSubmit={handleSubmit}>
            <Form.Group as={Row} id='name'>
              <Form.Label column xs={5}>
                Nombre{" "}
              </Form.Label>
              <Col xs={7}>
                <Form.Control
                  type='text'
                  required
                  defaultValue={currentProfile.Name}
                  ref={nameRef}
                  size='sm'
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} id='name'>
              <Form.Label column xs={5}>
                Apellido{" "}
              </Form.Label>
              <Col xs={7}>
                <Form.Control
                  type='text'
                  required
                  defaultValue={currentProfile.Surname}
                  ref={surnameRef}
                  size='sm'
                />
              </Col>
            </Form.Group>

            {/* Affiliation */}
            <Form.Group as={Row} id='affiliation' className='mt-2'>
              <Form.Label column xs={5}>
                Institución
              </Form.Label>
              <Col xs={7}>
                <Form.Select
                  aria-label='Default select example'
                  ref={affiliationRef}
                  value={selectedAffiliation}
                  onChange={handleDropdownChange}
                  placeholder='Select your Affiliation'
                  size='sm'
                  required
                >
                  <option value={currentProfile.Affiliation}>
                    {currentProfile.Affiliation}
                  </option>

                  {optionsAffiliation.map((option, index) => {
                    if (option.value === currentProfile.Affiliation) {
                      return (
                        <option key={index} value={option.value} selected>
                          {option.label}
                        </option>
                      )
                    } else {
                      return (
                        <option key={index} value={option.value}>
                          {option.label}
                          {/* {console.log(selectedAffiliation)} */}
                        </option>
                      )
                    }
                  })}
                </Form.Select>
                {selectedAffiliation === "other" && (
                  <div>
                    <Form.Label column xs={5}>
                      Institución:
                    </Form.Label>

                    <Form.Control
                      type='text'
                      // defaultValue={currentProfile.Affiliation}
                      ref={affiliationRef}
                      onChange={handleTextChange}
                      size='sm'
                      required
                      className='mt-1'
                    />
                  </div>
                )}
              </Col>
            </Form.Group>

            {/* <Form.Group as={Row} id='affiliation' className='mt-2'>
              <Form.Label column xs={5}>
                Afiliación
              </Form.Label>
              <Col xs={7}>
                <Form.Control
                  type='text'
                  required
                  defaultValue={currentProfile.Affiliation}
                  placeholder='Your affiliation'
                  ref={affiliationRef}
                  size='sm'
                />
              </Col>
            </Form.Group> */}

            <Form.Group as={Row} id='degree' className='mt-2'>
              <Form.Label column xs={5}>
                Título académico
              </Form.Label>
              <Col xs={7}>
                <Form.Select
                  aria-label='Default select example'
                  ref={degreeRef}
                  required
                  // defaultValue={currentProfile.Degree}
                  placeholder='Select your degree'
                  size='sm'
                >
                  <option value='' className='text-secondary'>
                    Select option
                  </option>
                  {optionsDegree.map((option, index) => {
                    return (
                      <option key={index} value={option.value}>
                        {option.label}
                      </option>
                    )
                  })}

                  {/* <option value="PhD" aria-label="PhD">Doctorado (Ph.D., Ph.D (c))</option>
                  <option value="Master" aria-label="Master">Maestria (Master)</option>
                  <option value="Bachelor"  aria-label="Bachelor">Licenciatura (Bachelor)</option>
                  <option value="NA"  aria-label="NA">NA (NA)</option> */}
                </Form.Select>
              </Col>
            </Form.Group>

            <Form.Group as={Row} id='degree' className='mt-2'>
              <Form.Label column xs={5}>
                Ocupación
              </Form.Label>
              <Col xs={7}>
                <Form.Select
                  aria-label='Default select example'
                  ref={occupationRef}
                  // defaultValue={currentProfile.occupation}
                  required
                  placeholder='Select your degree'
                  size='sm'
                >
                  <option value='' className='text-secondary'>
                    Select option
                  </option>
                  {optionsOccupation.map((option, index) => {
                    return (
                      <option key={index} value={option.value}>
                        {option.label}
                      </option>
                    )
                  })}

                  {/* <option value="Profesional" aria-label="Profesional">Profesional (Professional)</option>
                  <option value="Docencia" aria-label="Docencia">Docencia (Teaching)</option>
                  <option value="Investigador" aria-label="Investigador">Investigador (Research)</option>
                  <option value="Estudiante" aria-label="Estudiante">Estudiante (Student)</option> */}
                </Form.Select>
              </Col>
            </Form.Group>
            {/* Paper ID */}
            <div className='w-100 fs-6 text-center'>
              Expositores: por favor incluye el numero de tu documento.
            </div>
            <div className='w-100 fs-16 text-secondary mt-0 text-center'>
              Presenters: please include you paper ID.
            </div>

            <Form.Group as={Row} id='paperID' className='mt-3'>
              <Form.Label column xs={5}>
                Paper ID
              </Form.Label>
              <Col xs={7}>
                <Form.Control
                  type='text'
                  placeholder='Paper ID'
                  ref={paperRef}
                  size='sm'
                />
              </Col>
            </Form.Group>

            <Button disabled={loading} className='w-100 mt-4' type='submit'>
              Continuar | Next
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </CenteredContainer>
  )
}
